import { SaSet } from './types';

const dg: SaSet = {
  categories: [
    'Apparaten & bestanden',
    'Online samenwerken',
    'Informatie vinden',
    'Veilig delen',
    'Zelfredzaamheid',
  ],
  items: [
    // Apparaten & bestanden
    { category: 'Apparaten & bestanden', text: 'Ik vind een bestand snel terug, ook als ik het een tijdje niet heb gebruikt.', quick: true },
    { category: 'Apparaten & bestanden', text: 'Ik orden mijn documenten in mappen met namen waar ik later iets aan heb.' },
    { category: 'Apparaten & bestanden', text: 'Ik geef mijn bestanden duidelijke namen, zodat ik weet wat erin zit.' },
    { category: 'Apparaten & bestanden', text: 'Ik weet of een bestand op mijn apparaat staat of in de cloud.', quick: true },
    { category: 'Apparaten & bestanden', text: 'Ik kan vlot wisselen tussen mijn laptop, telefoon en tablet zonder de draad kwijt te raken.' },
    { category: 'Apparaten & bestanden', text: 'Ik houd genoeg ruimte vrij op mijn apparaat door spullen op te ruimen die ik niet meer nodig heb.' },

    // Online samenwerken
    { category: 'Online samenwerken', text: 'Ik werk met collega’s in hetzelfde document zonder dat we elkaars werk overschrijven.', quick: true },
    { category: 'Online samenwerken', text: 'Ik plaats een opmerking of suggestie in een document in plaats van zomaar iets te wijzigen.' },
    { category: 'Online samenwerken', text: 'Ik plan een online afspraak in en stuur de uitnodiging zonder gedoe.' },
    { category: 'Online samenwerken', text: 'Ik weet hoe ik tijdens een videogesprek mijn scherm deel.', quick: true },
    { category: 'Online samenwerken', text: 'Ik vind de laatste versie van een gedeeld document terug, ook als anderen het hebben aangepast.' },
    { category: 'Online samenwerken', text: 'Ik kies het juiste kanaal om iets te delen, bijvoorbeeld een chatbericht of een mail.' },

    // Informatie vinden
    { category: 'Informatie vinden', text: 'Ik vind met een paar gerichte zoekwoorden meestal snel wat ik nodig heb.', quick: true },
    { category: 'Informatie vinden', text: 'Ik verfijn mijn zoekopdracht als de eerste resultaten niet kloppen.' },
    { category: 'Informatie vinden', text: 'Ik kijk wie er achter een bron zit voordat ik de informatie overneem.', quick: true },
    { category: 'Informatie vinden', text: 'Ik vergelijk een paar bronnen voordat ik iets als waar aanneem.' },
    { category: 'Informatie vinden', text: 'Ik herken een advertentie of gesponsord resultaat tussen de zoekresultaten.' },
    { category: 'Informatie vinden', text: 'Ik bewaar een handige pagina zodat ik hem later makkelijk terugvind.' },

    // Veilig delen
    { category: 'Veilig delen', text: 'Ik denk eerst na wie iets mag zien voordat ik een link deel.', quick: true },
    { category: 'Veilig delen', text: 'Ik weet het verschil tussen een link die iedereen kan openen en een link voor een select groepje.' },
    { category: 'Veilig delen', text: 'Ik controleer of ik mijn bericht naar de juiste persoon stuur voordat ik op verzenden druk.' },
    { category: 'Veilig delen', text: 'Ik gebruik voor verschillende accounts verschillende wachtwoorden.' },
    { category: 'Veilig delen', text: 'Ik let erop dat ik gevoelige gegevens niet zomaar in een open chat plak.' },
    { category: 'Veilig delen', text: 'Ik trek een deellink weer in als iemand er geen toegang meer toe hoeft te hebben.' },

    // Zelfredzaamheid
    { category: 'Zelfredzaamheid', text: 'Als er iets niet werkt, probeer ik het eerst zelf op te lossen voordat ik hulp vraag.', quick: true },
    { category: 'Zelfredzaamheid', text: 'Ik herstart een apparaat of programma als het hapert, om te kijken of dat helpt.' },
    { category: 'Zelfredzaamheid', text: 'Ik zoek zelf een uitleg op als ik niet weet hoe iets moet.' },
    { category: 'Zelfredzaamheid', text: 'Ik durf nieuwe knoppen en instellingen uit te proberen zonder bang te zijn dat ik iets kapotmaak.' },
    { category: 'Zelfredzaamheid', text: 'Ik kan goed uitleggen wat er misgaat als ik hulp nodig heb.' },
    { category: 'Zelfredzaamheid', text: 'Ik raak niet snel uit het veld geslagen als een scherm er ineens anders uitziet.' },
  ],
};

export default dg;
